import { JobStatusPill } from 'components/FbUI/JobStatusPill'
import { ContactRequestJobResponse } from 'models/contact_request'
import { PiCalendar, PiClock } from 'react-icons/pi'
import { formatDate2 } from 'utils/formatting'

type Props = {
  contactRequest: ContactRequestJobResponse
}

export function ContactRequestCard({ contactRequest }: Props) {
  return (
    <div className="flex rounded-lg border border-line bg-white shadow-sm">
      <div className="flex flex-col w-full">
        <div className="flex flex-col gap-3 p-2">
          <div className="flex justify-between">
            <h2
              className="text-base font-semibold leading-[2em] text-fg"
              style={{ lineHeight: '2em' }}
            >
              {contactRequest.campaign?.name}
            </h2>
            <JobStatusPill
              statusValue={contactRequest.status?.id}
              statusLabel={contactRequest.status?.label}
            />
          </div>

          <div className="flex h-5 items-center gap-2 pb-2">
            <div className="flex items-center gap-1 justify-between w-full">
              <div
                className="flex gap-3 text-xs font-light leading-[1.8em] text-fg w-full"
                style={{ lineHeight: '1.8em' }}
              >
                <div className="w-1/2 flex justify-between">
                  <div>Unique Companies</div>{' '}
                  <div>{contactRequest?.unique_companies_count}</div>
                </div>
                <div className="border-r border-gray-200 my-1" />
                <div className="w-1/2 flex justify-between">
                  <div>Credits Used</div>{' '}
                  <div>{contactRequest?.credits_used || '0'}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-between bg-gray-50 p-2 text-xs">
          <div className="flex items-center gap-2">
            <PiCalendar />{' '}
            <span className="text-xxs">
              {' '}
              Created {formatDate2(contactRequest.created)}
            </span>
          </div>

          <div className="flex items-center gap-2">
            <PiClock />{' '}
            <span className="text-xxs">
              Updated {formatDate2(contactRequest.modified)}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
